<template>
  <div :id="id" class="configurator-step" v-bind:class="sizeClass">
    <div v-if="title" class="configurator-step-header">
      <h3>{{ title }}</h3>
    </div>
    <div v-if="searchable && this.isActive" class="configurator-step-search">
      <i class="fa fa-search" aria-hidden="true"/>
      <input type="text" name="searchable" v-model="search"/>
    </div>
    <div class="loading" v-if="isLoading"><span class="spinner"></span></div>
    <component v-else :is="contentComponent" :name="name" :options="options" :priority="priority" :isActive="isActive" />
  </div>
</template>

<script>
import ConfiguratorStepList from './ConfiguratorStepList'
import ConfiguratorStepPurpose from './ConfiguratorStepPurpose'
import ConfiguratorStepExtras from './ConfiguratorStepExtras'
import ConfiguratorStepMileage from './ConfiguratorStepMileage'
import ConfiguratorStepEmail from './ConfiguratorStepEmail'
import ConfiguratorStepIntermission from './ConfiguratorStepIntermission'
import ConfiguratorStepDealerEmail from './ConfiguratorStepDealerEmail'
import ConfiguratorStepDealerIntermission from './ConfiguratorStepDealerIntermission'

import { Flow } from '../services/flow'

export default {
  name: 'ConfiguratorStep',
  components: {
    ConfiguratorStepList,
    ConfiguratorStepPurpose,
    ConfiguratorStepExtras,
    ConfiguratorStepMileage,
    ConfiguratorStepEmail,
    ConfiguratorStepIntermission,
    ConfiguratorStepDealerEmail,
    ConfiguratorStepDealerIntermission
  },
  props: ['name', 'title', 'size', 'priority', 'searchable', 'className'],
  data: function() {
    return {
      loading: false,
      search: null,
    }
  },
  computed: {
    id: function() {
      return "step-" + this.name;
    },
    isLoading: function() {
      return !this.isInactive && this.$store.state.options[this.name] == null;
    },
    options: function() {
      let options = this.$store.state.options[this.name];
      return (this.searchable && this.search)
        ? this.applyFilter(options, this.search)
        : options;
    },
    contentComponent: function() {
      return 'ConfiguratorStep' + Flow.step(this.name).type;
    },
    isInactive: function() {
      return this.isActive == false;
    },
    isActive: function() {
      return Flow.isActiveStep(this.$store, this.name);
    },
    isPristine: function() {
      return this.$store.state.pristine;
    },
    sizeClass: function() {
      if(!this.className) {
        return 'configurator-step-' + this.size;
      }
      return 'configurator-step-' + this.size + ' ' + this.className;
    }
  },
  methods: {
    applyFilter: (options, search) => {
      let s = new RegExp(`${search.toLowerCase()}`, 'i');
      return options ? options.filter((option) => s.test(option.name)) : options;
    },
    scrollToActive: () => {
      const step = document.getElementById('step-'+this.name)
      if (!step) { return };
      const stepList = step.querySelector('.configurator-step-list');

      const activeElement = stepList.querySelector('li.active');
      if (!activeElement) { return };
      
      stepList.scrollTo({
          top: activeElement.offsetTop - (stepList.offsetHeight / 2) + 34,
          left: 0,
            behavior: 'smooth'
      });
    },
  },
  watch: {
    isPristine: function(value) {
      if (value) { this.mileage = null; }
    }
  },
  mounted: function() {
    this.scrollToActive();
  },
  updated: function() {
    this.scrollToActive();
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

@keyframes spinner {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.loading { display: block; text-align: center; }

.loading .spinner {
  display: inline-block;
  border: 7px solid #ddd;
  border-left-color: #888;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin: 20px auto;
  text-align: center;
  animation: spinner 1.2s linear infinite;
}

.configurator-step {
  float: left;
  height: 525px;
  overflow: hidden;
  transition:1000ms background-color ease-in-out;

  @media screen and (max-height:750px) {
    height:500px;
  }
  @media screen and (min-width:1200px) and (max-height:1100px) {
    height:420px;
  }
  @media screen and (min-width:1200px) and (max-height:850px) {
    height:400px;
  }

  @media screen and (min-width:1200px) and (max-height:750px) {
    height:300px;
  }

  @include breakpoint(frommediumlarge) {
    border-right: 1px solid #d8d8d8;
  }

  &.current {
    background:rgba(#54a324, .05);
  }
}

.configurator-step-4x {
  height: 525px;
  overflow:scroll;

  @media screen and (min-width:1200px) and (max-height:1100px) {
    height:430px;
  }

  @media screen and (min-width:1200px) and (max-height:750px) {
    height:300px;
  }
}

// @include breakpoint(fromlarge) {
//   .configurator-step {
//     height: 520px;
//   }
// }


@include breakpoint(fromsmall) {
  .configurator-step-1x,
  .configurator-step-2x,
  .configurator-step-4x {
    width: 300px;
  }
}

@include breakpoint(frommediumlarge) {
  .configurator-step-1x,
  .configurator-step-2x,
  .configurator-step-4x {
    width: 240px;
  }
}

@include breakpoint(extralarge) {
  .configurator-step-1x {
    width: 278px;
  }
}

.configurator-step-2x {
  width: 500px;
}

// .configurator-step-4x {
//   width: 90vw;

//   @include breakpoint(extralarge) {
//       width:1000px;
//   }
// }

.configurator-step.inactive {
  opacity: 0.5;
}

.configurator-step-header {
	border-bottom: 1px solid #d8d8d8;
	padding: 20px;
  @include breakpoint(frommediumlarge) { 
    margin: 0;
    padding: 20px;
  }
}

.configurator-step-header h3 {
  margin:0;
  padding:0;
	color: #3a3a3a;
  font-size: 18px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  white-space: nowrap;

  @include breakpoint(fromgiant) {
    font-size: 16px;
  }

  @include breakpoint(extralarge) {
    font-size: 18px;
  }
}

@include breakpoint(small) {
  .configurator-step-1x,
  .configurator-step-2x,
  .configurator-step-4x {
    width: 300px;
  }
}



.configurator-step-search {
  position: relative;
  width: 100%;
  padding: 8px;

  input {
    height: 43px;
    width: 100%;
    border: 1px solid #DADADA;
    padding: 0 12px;
    font-size: 16px;
    color: #444;
  }

  .fa-search {
    position: absolute;
    width: 20px;
    height: 21px;
    right: 21px;
    top: calc(50% - 10px);
    z-index: 1;
    font-size: 20px;
    color: #DADADA;
  }

  & + .configurator-step-list {
    top: 108px !important;
    margin: 0 3px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStep.vue